<!-- content begin -->
<div id="content" class="no-bottom no-top">
    <div id="top"></div>


    <!-- section begin -->
    <section id="subheader" class="text-light" data-bgimage="url(assets/images/background/10.jpg)"
        data-stellar-background-ratio=".2" style="background: url(assets/images/background/16.jpg) 0% 0px / cover; ">
        <div class="overlay-bg t50" style="background: rgba(30, 30, 30, .5)">

            <div class="container">
                <div class="row">
                    <div class="col-md-12">
                        <h1>About the post</h1>
                    </div>
                </div>
            </div>

        </div>

    </section>
    <!-- section close -->



    <div class="row notifi_main ">
        <div class="col-md-12">
            <h2>
                Junior Vocational Consultants
            </h2>

            <p class="para_main_notify">
                The engagement of Junior Vocational Consultants
                (JVCs) for NSTIs to take care of Training of CTS courses along
                with New Age Courses (CTS) and High-End courses. (CTS)
            </p>
        </div>
    </div>


    <!-- section begin -->
    <section id="section-services">
        <div class="container">

            <div class="row align-items-center">
                <div class="col-md-12">
                    <div class="row sequence">

                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-graduation-cap" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Qualifications and experience:</h3>

                                    <p> <span class="step_no">1</span> 1. B.Tech / B.E (having minimum of 2 years of
                                        Experience) / Diploma (having minimum of 5 years of Experience) / CITS with at
                                        least 3 years of experience in the requisite field. </p>
                                    <p> <span class="step_no">2</span> 2. Retired Government employees with Level 7 and
                                        above in the Pay Matrix, having experience of at least 5 years in the required
                                        domain field would also be eligible for the position. </p>
                                    <p> <b> Note: </b>The candidature of the candidate who is appearing in exam for JCs
                                        of training profiles, shall be cancelled if the candidate fails in practical
                                        examination i.e., Qualifying practical examination is mandatory for Training
                                        profile JCs. </p>


                                </div>
                            </div>
                        </div> -->
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>General Conditions </h3>



                                    <p> <span class="step_no">1</span>Junior Vocational Consultants will be engaged for
                                        a period of eleven months from the
                                        date of Engagement. </p>
                                    <p> <span class="step_no">2</span> The services of JVCs may be continued for a
                                        period of another 11 Months with a break
                                        of 1 Month if found suitable by the competent authority of
                                        NSTI/RDSDE/DGT/CSTARI.
                                    </p>
                                    <p> <span class="step_no">3</span> Retired Government employees with experience in
                                        the relevant field would also be
                                        eligible for selection as Junior Vocational Consultants
                                    </p>
                                    <p> <span class="step_no">4</span> Consultants shall be appointed on a full-time
                                        basis and would not be permitted to take
                                        up any other assignment during the period of Consultancy.
                                    </p>
                                    <p> <span class="step_no">5</span> The engagement is purely on temporary nature and
                                        the appointment can be cancelled
                                        at any time without providing any reason for it. </p>
                                    <p> <span class="step_no">6</span> The reservation policy applicable for Central
                                        Government services should be strictly
                                        followed in the selection process of JVCs
                                    </p>
                                    <p> <span class="step_no">7</span> An agreement on stamp paper of Rs.100 /- duly
                                        notarized, must be signed between the
                                        Director of the Institute and incumbent (Junior Vocational Consultant). </p>
                                    <p> <span class="step_no">8</span>A waitlist of qualified candidates (nearly 2 times
                                        the no. of vacancy of JVCs) is to be
                                        prepared & should kept in panel for three years. They will be considered against
                                        transfer, resignation, death etc. cases.</p>


                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Number of Junior Vocational Consultants:</h3>
                                    <p> The total number of consultants to be engaged shall depend on the actual
                                        requirement at a
                                        particular point of Time
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Qualification and Experience: </h3>
                                    <p> <span class="step_no">1</span> Bachelor’s degree or higher in relevant field
                                        from recognized University or Institute with minimum ONE
                                        year of post-qualification experience </p>
                                    <p> <span class="step_no">2</span>Diploma in Engineering or Technology in the
                                        relevant field from recognized Board or Institute with Two
                                        years post-qualification experience;
                                    </p>
                                    <p> <span class="step_no">3</span>Bachelor’s degree or higher in any field from
                                        recognized University/Institute or National Trade Certificate
                                        (NTC) /National Apprenticeship Certificate (NAC) from National Council of
                                        Vocational Education and
                                        Training (NCVET previously NCVT) in relevant field with Three year of
                                        Post-Qualification experience
                                    </p>
                                    <p> <span class="step_no">4</span>Should possess CITS certificate i.e. National
                                        Crafts Instructor Certificate (NCIC) in relevant trades. Those
                                        CTS trades for which CITS is not available (as attached at Annexure 2), such
                                        candidates may be exempted for
                                        having mandatory CITS (NCIC certificate)
                                    </p>
                                    <p>
                                        <span class="step_no">5</span> Retired Government employees with Level 6 and
                                        above in the Pay
                                        Matrix, having
                                        experience of at least 5 years in the required domain field would also be
                                        eligible for the
                                        position.
                                    </p>
                                    <p>
                                        <span class="step_no">6</span> The candidature of the candidate who is appearing
                                        in exam for
                                        JVCs of training
                                        profiles, shall be liable cancelled if the candidate fails in practical
                                        examination i.e., Qualifying
                                        practical examination is mandatory for Training profile JVCs.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->


                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                          <div class="feature-box style-2 left">
                              <i class="fa fa-gavel"></i>
                              <div class="text para_cls">
                                  <h3>Age Limit: </h3>
                                  <p>  Upper Age limit of 40 Years for all as on Last date of receipt of Application (Except for Retired Govt Servant) </p>

                              </div>
                          </div>
                      </div>
                      <!-- feature box close -->

                      <div class="col-md-12 feature-box mb40 sq-item wow">
                        <div class="feature-box style-2 left">
                          <i class="fa fa-calendar"></i>
                          <div class="text para_cls">
                            <h3>Last Date:</h3>
                            <p style="color: red;"><b> Last date for Applying Online 31st July 2021 </b> </p>
                          </div>
                        </div>
                      </div>
                      <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3>Score Card Calculations</h3>

                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Examination/Experience/Qualification </th>
                                                        <th style="text-align: center;">Split up</th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>CBT Examination (Maximum 100 Marks)</td>
                                                        <td>Total CBT Marks obtained out of 100
                                                            Marks </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Practical Examination (Maximum 100 Marks) </td>
                                                        <td> Total Practical Marks obtained out of 100
                                                            Marks
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Experience (Maximum 10 Marks) </td>
                                                        <td>
                                                            <p>2 Marks per year of Experience after
                                                                acquiring minimum qualification &
                                                                experience as prescribed in Para C above.
                                                            </p>
                                                            <p> (Maximum limit is 10 Marks for 5 years of
                                                                experience after acquiring minimum
                                                                qualification & experience as
                                                                prescribed in Para C above.)</p>
                                                        </td>

                                                    </tr>

                                                    <tr class="last_tr">
                                                        <td></td>
                                                        <td>Total Marks </td>
                                                        <td class="num_marks"> 210 </td>
                                                        <td></td>
                                                    </tr>

                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <!-- <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> proposed process </h3>

                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Activity/Process </th>
                                                        <th style="text-align: center;">To be done by</th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>Trade & Institute wise Requirement of JVCs </td>
                                                        <td>by CFI Division </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Publishing of the Applications Centrally
                                                            Online for engaging Junior Vocational
                                                            Consultants </td>
                                                        <td> by NIMI
                                                        </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Scrutinizing of Applications received,
                                                            Issue of Admit Card </td>
                                                        <td> by NIMI
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>Conduct of All India CBT Exam for selection of
                                                            pool of candidates Online </td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>Calling the CBT qualified candidates Regional wise for
                                                            Practical Exams in order of Merit (based on CBT marks)
                                                            in 1:6 ratio digitally </td>
                                                        <td>
                                                            by the
                                                            Committee
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>Practical Exams to be conducted Region wise for above
                                                            sorted candidates
                                                        </td>
                                                        <td>
                                                            by NSTIs
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>Calculation of Score Card/Result of the Candidates (3
                                                            Times the number of JVCs) in order of merit as per the
                                                            Score card rule mentioned in JC guidelines </td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>

                                                    <tr>
                                                        <td>7</td>
                                                        <td>Calculation of Score Card/Result of the Candidates (3
                                                            Times the number of JVCs) in order of merit as per the
                                                            Score card rule mentioned in JC guidelines </td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>Selected candidates Panel list (3 Times the number of
                                                            JVCs) with scorecard to be sent from NIMI to DGT
                                                            HQRS for approval</td>
                                                        <td>
                                                            by NIMI
                                                        </td>

                                                    </tr>
                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div> -->
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Tie Breaker Rules</h3>


                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                In case of tie between the Marks of set of candidates, the following
                                                criteria will be applicable
                                                in Priority basis to settle the tie.
                                            </div>
                                            <div class="col-md-12">
                                                <table>

                                                    <tr>
                                                        <td>1</td>
                                                        <td> First Preference </td>
                                                        <td> Practical Marks
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Second Preference </td>
                                                        <td>CBT Marks </td>

                                                    </tr>

                                                    <tr>
                                                        <td>3</td>
                                                        <td>Third Preference </td>
                                                        <td>Retired Govt. Employee </td>


                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>Fourth Preference </td>
                                                        <td>Degree or Higher qualification in relevant field </td>


                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>Fifth Preference </td>
                                                        <td>Diploma in relevant field
                                                        </td>


                                                    </tr>

                                                </table>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 mb40 sq-item wow sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-gavel"></i>
                                <div class="text para_cls">
                                    <h3>Entitlements of Consultants: </h3>
                                    <p> <span class="step_no">1</span> The full-time candidates will be paid a monthly
                                        consolidated remuneration of Rs.
                                        35,000/ </p>
                                    <p> <span class="step_no">2</span>In the case of retired Govt. servants, the
                                        remuneration shall be as per prevailing DoPT norms.
                                    </p>
                                    <p> <span class="step_no">3</span> The Consultants will not be eligible for
                                        Government Accommodation or House Rent
                                        Allowance, CGHS facility Official email i.d., Government identification card,
                                        internet
                                        connection, telephone, etc.

                                    </p>
                                    <p> <span class="step_no">4</span> The guidelines for engaging Central Govt. Retired
                                        Employees as
                                        Junior
                                        Vocational
                                        Consultants recruited through this exam will have their remuneration and terms
                                        governed by O.M. no
                                        F.No. 3- 25/2020-E III A issued by Department of Expenditure dated 9.12.2020
                                        regarding regulation of
                                        Remuneration in case of Contract Appointment of Retired Central Government
                                        Employee. Further, the
                                        retired govt. employees will be hired as per existing guidelines of GoI,
                                        available at the
                                        time.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->
                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> TA/DA:</h3>
                                    <p> If the Tour program is in interest of Public Service, then they are entitled to
                                        allowances as applicable
                                        in the Level-6
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Leave: </h3>
                                    <p> The JVCsshall be entitled to leave of 8 days in a year on pro rata basis.
                                        Additional leave without pay
                                        wouldbe permitted upon approval by the Concerned Competent Authority.

                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Conflict of interest:
                                    </h3>
                                    <p> He/she will be expected to display utmost honesty, secrecy of office and
                                        sincerely while discharging
                                        his/her duties. In case, the services of the Consultant are not found
                                        satisfactory or found in conflict
                                        with the interests of the Government, his/her services will be liable for
                                        discontinuation without
                                        assigning any reason
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-tasks" aria-hidden="true"></i>
                                <div class="text para_cls">
                                    <h3> Termination Notice:
                                    </h3>
                                    <p> The Competent Authority can cancel the appointment at any time without providing
                                        any reason for it.
                                        However, in the normal course it will provide one month’s notice to the
                                        Consultant.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3>Junior Vocational Consultants requirement in NSTIs</h3>

                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>CTS Trades / NSTI(G) </th>
                                                        <th style="text-align: left;">Junior Vocational Consultant for
                                                            NSTI(G)</th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>Technician Mechatronics</td>
                                                        <td>8 </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Electrician - Power Distribution </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Solar Technician (Electrical) </td>
                                                        <td> 9 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>IoT Technician (Smart Health Care) </td>
                                                        <td> 4 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td>IoT Technician (Smart Agriculture) </td>
                                                        <td> 7 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td>Soil Testing & Crop Technician </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td>Additive Manufacturing Tech. (3D Printing) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>Smart Phone Tech. cum app test </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>Geo Informatics </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td>Remotely Piloted Aircraft - Drone Pilot </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>Machinist </td>
                                                        <td> 8 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>Machinist (Grinder) </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td>Tool & Die Maker </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>Foundryman </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>Welder </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>Turner </td>
                                                        <td> 2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td> WSC </td>
                                                        <td> 13 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td>ED </td>
                                                        <td> 13 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>Employability Skills </td>
                                                        <td> 15 </td>
                                                    </tr>
                                                    <tr class="last_tr">
                                                        <td></td>
                                                        <td>Total Marks </td>
                                                        <td> 91 </td>
                                                        <td></td>
                                                    </tr>

                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->



                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> JVCs requirement for General cadre in NSTI(G) : </h3>
                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Name of the Institutes </th>
                                                        <th>Junior
                                                            Vocational
                                                            Consultant
                                                        </th>
                                                        <th>Name of Trade</th>
                                                        <th>No of Junior
                                                            Vocational
                                                            Consultant</th>
                                                    </thead>

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="6">1</td>
                                                        <td rowspan="6">NSTI Calicut </td>
                                                        <td rowspan="6">7</td>
                                                        <td>Electrician - Power
                                                            Distribution </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Solar Technician
                                                            (Electrical) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Health Care) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="6">2</td>
                                                        <td rowspan="6">NSTI Hyderabad (V) </td>
                                                        <td rowspan="6">8</td>
                                                        <td>Solar Technician
                                                            (Electrical)
                                                        </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Geo Informatics </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Machinist </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="5">3</td>
                                                        <td rowspan="5">NSTI Hyderabad R </td>
                                                        <td rowspan="5">5</td>
                                                        <td>IoT Technician (Smart
                                                            Health Care)
                                                        </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Remotely Piloted
                                                            Aircraft - Drone Pilot </td>
                                                        <td>1</td>
                                                    </tr>

                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="5">4</td>
                                                        <td rowspan="5">NSTI Bhubaneshwar </td>
                                                        <td rowspan="5">5</td>
                                                        <td>Solar Technician (Electrical </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Health Care) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="7">5</td>
                                                        <td rowspan="7">NSTI Bengaluru </td>
                                                        <td rowspan="7">8</td>
                                                        <td>Solar Technician
                                                            (Electrical) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Agriculture)</td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Machinist</td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Welder</td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->


                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="6">6</td>
                                                        <td rowspan="6">NSTI Chennai </td>
                                                        <td rowspan="6">8</td>
                                                        <td>Technician
                                                            Mechatronics</td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Agriculture)
                                                        </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Tool & Die Maker </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="5">7</td>
                                                        <td rowspan="5">NSTI Jodhpur </td>
                                                        <td rowspan="5">5</td>
                                                        <td>Solar Technician (Electrical </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Smart Phone Tech. cum
                                                            app test. </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="8">8</td>
                                                        <td rowspan="8">NSTI Howrah </td>
                                                        <td rowspan="8">12</td>
                                                        <td>Technician
                                                            Mechatronics </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Machinist </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Machinist (Grinder)
                                                        </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Foundryman </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="5">9</td>
                                                        <td rowspan="5">NSTI Ludhiana </td>
                                                        <td rowspan="5">6</td>
                                                        <td>IoT Technician (Smart
                                                            Agriculture)
                                                        </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Turner </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="7">10</td>
                                                        <td rowspan="7">NSTI Mumbai </td>
                                                        <td rowspan="7">10</td>
                                                        <td>Technician
                                                            Mechatronics </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Solar Technician
                                                            (Electrical) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Machinist
                                                        </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Health Care)
                                                        </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->




                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="6">11</td>
                                                        <td rowspan="6">NSTI Dehradun </td>
                                                        <td rowspan="6">6</td>
                                                        <td>Solar Technician
                                                            (Electrical) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Health Care)
                                                        </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="5">12</td>
                                                        <td rowspan="5">NSTI Haldwani </td>
                                                        <td rowspan="5">5</td>
                                                        <td>Solar Technician
                                                            (Electrical) </td>
                                                        <td>1</td>
                                                    </tr>

                                                    <tr>
                                                        <td>IoT Technician (Smart
                                                            Health Care) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="5">13</td>
                                                        <td rowspan="5">NSTI Kanpur </td>
                                                        <td rowspan="5">6</td>
                                                        <td>Technician
                                                            Mechatronics </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Additive Manufacturing
                                                            Tech.(3D Printing) </td>
                                                        <td>1</td>
                                                    </tr>

                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employability Skills </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row Start-->
                                                    <tr class="last_tr">
                                                        <td> </td>
                                                        <td>TOTAL</td>
                                                        <td>91 </td>
                                                        <td></td>
                                                        <td> </td>

                                                    </tr>
                                                    <!--Row End-->
                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3>JVCs requirement for Women cadre in NSTI(W):</h3>

                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>CITS Trades / NSTI(W) </th>
                                                        <th style="text-align: left;">Junior Vocational Consultant for
                                                            NSTI-W</th>
                                                    </thead>

                                                    <tr>
                                                        <td>1</td>
                                                        <td>Dress Making (1 YEAR)</td>
                                                        <td>11 </td>
                                                    </tr>

                                                    <tr>
                                                        <td>2</td>
                                                        <td>Secretarial Practice (1 YEAR) </td>
                                                        <td> 10 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>3</td>
                                                        <td>Front Office Assistant (1 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>4</td>
                                                        <td>Electronics Mechanic (2 YEAR) </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>5</td>
                                                        <td> Basic Cosmetology (1 YEAR) </td>
                                                        <td> 13 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>6</td>
                                                        <td> Computer Operator & Programming Assistant (1 YEAR) </td>
                                                        <td> 11 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>7</td>
                                                        <td> Architectural Draughtsman (2 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>8</td>
                                                        <td> Desk Top Publishing Operator (1 YEAR) </td>
                                                        <td> 3 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>9</td>
                                                        <td>Fruit & Vegetable Processing (1 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>10</td>
                                                        <td>Stenographer Secretarial Assistant (Hindi) (1 YEAR) </td>
                                                        <td> 5 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>11</td>
                                                        <td> Fashion Design & Technology (1 YEAR) </td>
                                                        <td> 12 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>12</td>
                                                        <td>Computer Aided Embroidery & Designing (1 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>13</td>
                                                        <td>Interior Design & Decoration (1 YEAR) </td>
                                                        <td> 3 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>14</td>
                                                        <td> Food Production (General) (1 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>15</td>
                                                        <td>Catering & Hospitality (1 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>16</td>
                                                        <td>Travel & Tour Assistant (1 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>17</td>
                                                        <td>Stenographer Secretarial Assistant (English) (1 YEAR) </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>18</td>
                                                        <td> Draughtsman Civil (2 YEAR) </td>
                                                        <td> 1 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>19</td>
                                                        <td> Technician Mechatronics (2 YEAR) </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>20</td>
                                                        <td>Electrician - Power Distribution (2 YEAR) </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>21</td>
                                                        <td> Solar Technician (Electrical) (1 YEAR) </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>22</td>
                                                        <td> IoT Technician (Smart Health Care) (1 YEAR) </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>23</td>
                                                        <td> IoT Technician (Smart City) (1 YEAR) </td>
                                                        <td> 10 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>24</td>
                                                        <td>IoT Technician (Smart Agriculture) (1 YEAR) </td>
                                                        <td> 5 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>25</td>
                                                        <td>Soil Testing & Crop Technician (1 YEAR) </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>26</td>
                                                        <td>Additive Manufacturing Tech. (3D Printing) (1 YEAR) </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>27</td>
                                                        <td>Smart Phone Tech cum app test. (6 months) </td>
                                                        <td> 6 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>28</td>
                                                        <td>Geo Informatics (1 YEAR) </td>
                                                        <td> 2 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>29</td>
                                                        <td>Remotely Piloted Aircraft -Drone Pilot (6 months) </td>
                                                        <td> 0 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>30</td>
                                                        <td>ED (0nly for Electronic Mechanic Trade) </td>
                                                        <td> 6 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>31</td>
                                                        <td>WSC </td>
                                                        <td> 12 </td>
                                                    </tr>
                                                    <tr>
                                                        <td>32</td>
                                                        <td>Employment Skill</td>
                                                        <td> 21 </td>
                                                    </tr>
                                                    <tr class="last_tr">
                                                        <td></td>
                                                        <td>Total Marks </td>
                                                        <td> 146 </td>
                                                        <td></td>
                                                    </tr>

                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->


                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> JVCs requirement for Women cadre in NSTI(W): </h3>
                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Name of the Institutes </th>
                                                        <th>Junior Consultant</th>
                                                        <th>Name of Trade</th>
                                                        <th>No of Junior Vocational Consultant</th>
                                                    </thead>

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="9">1</td>
                                                        <td rowspan="9">NSTI W Noida </td>
                                                        <td rowspan="9">11</td>
                                                        <td>Front Office Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Stenographer Secretarial Assistant (Hindi) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Interior Design & Decoration </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Solar Technician(Electrical) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart Health Care) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="7">2</td>
                                                        <td rowspan="7">NSTI W Mumbai </td>
                                                        <td rowspan="7">7</td>
                                                        <td>Dress Making (1 YEAR) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Smart Phone Tech. cum app test </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="8">3</td>
                                                        <td rowspan="8">NSTI W Bangalore </td>
                                                        <td rowspan="8">8</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Interior Design & Decoration </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="8">4</td>
                                                        <td rowspan="8">NSTI W Trivandrum </td>
                                                        <td rowspan="8">8</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Additive Manufacturing Tech.(3D Printing) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Smart Phone Tech. cum app test </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="11">5</td>
                                                        <td rowspan="11">NSTI W Panipat </td>
                                                        <td rowspan="11">13</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fruit & Vegetable, Processing </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Stenographer Secretarial Assistant (Hindi) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Smart Phone Tech. cum app test </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Geo Informatics </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="10">6</td>
                                                        <td rowspan="10">NSTI W Kolkata </td>
                                                        <td rowspan="10">10</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Interior Design & Decoration </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Smart Phone Tech. cum app test </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="9">7</td>
                                                        <td rowspan="9">NSTI W Tura </td>
                                                        <td rowspan="9">9</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Travel & Tour Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Soil Testing & Crop Technician </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="9">8</td>
                                                        <td rowspan="9">NSTI W Indore </td>
                                                        <td rowspan="9">9</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Stenographer Secretarial Assistant (Hindi) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="10">9</td>
                                                        <td rowspan="10">NSTI W Vadodara </td>
                                                        <td rowspan="10">12</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Aided Embroidery &Designing </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Solar Technician(Electrical) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="12">10</td>
                                                        <td rowspan="12">NSTI W Jaipur </td>
                                                        <td rowspan="12">14</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Architectural Draughtsman </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Stenographer Secretarial Assistant (Hindi) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Draughtsman Civil </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Additive Manufacturing Tech.(3D Printing) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Geo Informatics </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="14">11</td>
                                                        <td rowspan="14">NSTI W Allahabad </td>
                                                        <td rowspan="14">16</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Computer Operator & Programming Assistant </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Desk Top Publishing Operator </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Stenographer Secretarial Assistant (Hindi) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Food Production (General) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Catering & Hospitality </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED (0nly for Electronic Mechanic Trade ) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>2</td>
                                                    </tr>
                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="4">12</td>
                                                        <td rowspan="4">NSTI W Mohali </td>
                                                        <td rowspan="4">4</td>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="6">13</td>
                                                        <td rowspan="6">NSTI W Shimla </td>
                                                        <td rowspan="6">6</td>
                                                        <td>Desk Top Publishing Operator </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="3">14</td>
                                                        <td rowspan="3">NSTI W Agartala </td>
                                                        <td rowspan="3">3</td>
                                                        <td>Dress Making </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="8">15</td>
                                                        <td rowspan="8">NSTI W Trichy </td>
                                                        <td rowspan="8">8</td>
                                                        <td>Secretarial Practice </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Desk Top Publishing Operator </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Smart Phone Tech. cum app test </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED (0nly for Electronic Mechanic Trade) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td> Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="6">16</td>
                                                        <td rowspan="6">NSTI W Patna </td>
                                                        <td rowspan="6">6</td>
                                                        <td>Fashion Design & Technology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart Health Care) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>IoT Technician (Smart City) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>ED (Only for Electronic Mechanic Trade) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr class="bdr_btm">
                                                        <td>17</td>
                                                        <td>NSTI W Goa </td>
                                                        <td>1</td>
                                                        <td>Basic Cosmetology </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="4">18</td>
                                                        <td rowspan="4">NSTI W Hyderabad </td>
                                                        <td rowspan="4">4</td>
                                                        <td>IoT Technician (Smart Agriculture) </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>Soil Testing & Crop Technician </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr>
                                                        <td>WSC </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Employment Skill </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <!--Row End-->
                                                    <!--Row start-->
                                                    <tr class="bdr_btm">
                                                        <td>19</td>
                                                        <td>NSTI W Jammu </td>
                                                        <td>1</td>
                                                        <td>Smart Phone Tech. cum app test. </td>
                                                        <td>1</td>
                                                    </tr>


                                                    <!--Row End-->
                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                        <!-- feature box begin -->
                        <div class="col-md-12 feature-box mb40 sq-item wow">
                            <div class="feature-box style-2 left">
                                <i class="fa fa-calculator"></i>
                                <div class="text">
                                    <h3> JVCs requirement for Extension Centers of NSTIs : </h3>
                                    <div class="container">
                                        <div class="row">

                                            <div class="col-md-12">
                                                <table>
                                                    <thead>
                                                        <th>S.No</th>
                                                        <th>Name of the Institutes </th>
                                                        <th>Name of Trade</th>
                                                        <th>Junior Vocational Consultant for Extension Centers</th>
                                                    </thead>

                                                    <!--Row start-->
                                                    <tr class="bdr_btm">
                                                        <td>1</td>
                                                        <td>Srinagar Extension Center </td>
                                                        <td>IoT Technician (Smart Health Care) </td>
                                                        <td>1</td>
                                                    </tr>

                                                    <!--Row End-->

                                                    <!--Row start-->
                                                    <tr>
                                                        <td rowspan="2">2</td>
                                                        <td rowspan="2">Leh Ladakh Extension Center </td>
                                                        <td>Smart Phone Tech. cum app test. </td>
                                                        <td>1</td>
                                                    </tr>
                                                    <tr class="bdr_btm">
                                                        <td>Solar Technician (Electrical) </td>
                                                        <td>1</td>
                                                    </tr>

                                                    <!--Row End-->
                                                    <tr class="last_tr">
                                                        <td></td>
                                                        <td>Total </td>
                                                        <td> </td>
                                                        <td>3</td>
                                                    </tr>

                                                </table>


                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>


                        </div>
                        <!-- feature box close -->

                                                <!-- feature box begin -->
                                                <div class="col-md-12 feature-box mb40 sq-item wow">
                                                    <div class="feature-box style-2 left">
                                                        <i class="fa fa-calculator"></i>
                                                        <div class="text">
                                                            <h3> Note : </h3>
                                                            <div class="container">
                                                                <div class="row">
                        
                                                                    <div class="col-md-12">
                                                                       <p>The location of the vacancies indicated are tentative only. The final posting locations may vary from time to time subject to the requirement of the Organisation</p>
                        
                                                                    </div>
                                                                </div>
                                                            </div>
                        
                        
                                                        </div>
                                                    </div>
                        
                        
                                                </div>
                                                <!-- feature box close -->

                    </div>
                </div>

                <!-- <div class="col-md-4">
      <figure class="picframe invert transparent hover-shadow rounded">
                            <span class="overlay-v">
            <span class="v-center">
              <span>
                <a id="play-video" class="video-play-button popup-youtube" href="https://www.youtube.com/watch?v=CmCIZ_aUAeQ">
                  <span></span>
                </a>
              </span>
            </span>
          </span>
                        <img src="assets/images/misc/2.jpg" class="img-fullwidth" alt="">
                    </figure>
    </div> -->
            </div>

        </div>
    </section>
    <!-- section close -->







</div>
<!-- content close -->




<style>
    #section-intro {
        background-image: url(assets/images/background/niminew.jpg);
        background-size: cover;
        background-position: 0% 0px;
        height: 80vh !important;
    }

    .notifi_main {
        text-align: center;
        padding: 40px 0px;
    }

    .notifi_main h2 {
        border-bottom: 6px solid #F56B55;
        width: fit-content;
        margin: 0 auto;
        padding: 0px 30px;
    }

    .notifi_main .descrip_cls {
        padding: 5px 0px;
        font-weight: 500;
        font-size: 21px;
    }

    .overlay-bg.t50 {
        background: rgba(30, 30, 30, .1);
    }

    table {
        width: 100%;
        margin-top: 10px;
    }

    th,
    td {
        padding: 10px;
    }

    thead {
        background-color: #F56B55;
        color: #fff;
    }

    tr:nth-child(odd) {
        background-color: #eee;
    }

    .step_no {
        left: 80px;
        height: 30px;
        width: 30px;
        background-color: #F56B55;
        border-radius: 50%;
        display: inline-block;
        font-size: 18px;
        text-align: center;
        color: #fff;
        margin-right: 10px;
        position: absolute;
    }

    .para_cls p {
        padding-left: 35px;
    }

    .num_marks {
        text-align: center;
    }

    .last_tr {
        background-color: #F56B55 !important;
        color: #fff;
    }

    .notifi_main_table h2 {

        width: fit-content;
        margin: 0 auto;
        padding: 50px 30px 10px;
        font-size: 23px;

    }

    .para_main_notify {
        padding: 20px 0px;
        width: 50%;
        margin: 0 auto;
    }

    #section-services {
        padding: 0px !important;
    }
</style>
